import { render, staticRenderFns } from "./View.vue?vue&type=template&id=f3b57c00&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&id=f3b57c00&prod&lang=css&"
import style1 from "./View.vue?vue&type=style&index=1&id=f3b57c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b57c00",
  null
  
)

export default component.exports